<footer class="sticky-footer bg-footer">
    <div class="container my-auto">
        <div class="copyright text-center my-auto">
            <div class="version">Versión: {{version}}<br>General Security © 2024. Todos los derechos reservados.</div>
        </div>
    </div>
</footer>